export function reloadToUpdate() {
  window.location.reload();
}
